(() => {
  if (customElements.get('scroll-break')) return;

  const ease = (p) => (p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2);

  class ScrollBreak extends HTMLElement {
    connectedCallback() {
      this.wipe = this.querySelector('[data-sb-wipe]');
      this.left = this.querySelector('[data-sb-left]');
      this.right = this.querySelector('[data-sb-right]');
      this.dot = this.querySelector('[data-sb-dot]');
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    update() {
      const theme = window.theme || {};
      const reduced = theme.motion ? theme.motion() === 'off' : false;
      let progress = 0.5;
      if (!reduced) {
        const rect = this.getBoundingClientRect();
        const total = Math.max(1, rect.height - window.innerHeight);
        progress = Math.max(0, Math.min(1, -rect.top / total));
      }
      this.apply(ease(progress), theme.isDesktop ? !theme.isDesktop() : window.innerWidth < 1024);
    }

    apply(e, mobile) {
      if (this.wipe) {
        this.wipe.style.clipPath = mobile
          ? `inset(${(72 - 44 * e).toFixed(2)}% 0 0 0)`
          : `inset(0 0 0 ${(68 - 40 * e).toFixed(2)}%)`;
      }
      if (this.left) {
        this.left.style.opacity = (1 - 0.62 * e).toFixed(3);
        this.left.style.transform = mobile ? `translateY(${(-24 * e).toFixed(1)}px)` : `translateX(${(-36 * e).toFixed(1)}px)`;
      }
      if (this.right) {
        this.right.style.opacity = (0.35 + 0.65 * e).toFixed(3);
        this.right.style.transform = mobile
          ? `translateY(${(24 * (1 - e)).toFixed(1)}px)`
          : `translateX(${(36 * (1 - e)).toFixed(1)}px)`;
      }
      if (this.dot) this.dot.style.left = `${(e * 100).toFixed(2)}%`;
    }
  }

  customElements.define('scroll-break', ScrollBreak);
})();
